const ScaleIcon = ({ size = 24, className = "" }) => (
  <svg
    className={`icon scale-icon ${className}`.trim()}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3.5v16.5" />
    <path d="M8 20h8" />
    <path d="M4.5 6.5h15" />
    <path d="M4.5 6.5 2 12.5M4.5 6.5 7 12.5M2 12.5a2.5 2.5 0 0 0 5 0Z" />
    <path d="M19.5 6.5 17 12.5M19.5 6.5 22 12.5M17 12.5a2.5 2.5 0 0 0 5 0Z" />
  </svg>
);

export default ScaleIcon;
